import { Solar, LunarUtil } from '../../services/lunar.js';

/**
 * 计算天干在特定地支的长生十二神（自坐）
 * @param {string} gan 天干
 * @param {string} zhi 地支
 * @returns {string} 长生十二神
 */
const calculateDiShi = (gan, zhi) => {
  const ganIndex = LunarUtil.GAN.indexOf(gan) - 1; // 0-based
  const zhiIndex = LunarUtil.ZHI.indexOf(zhi) - 1; // 0-based
  
  if (ganIndex < 0 || zhiIndex < 0) return "";

  const offset = LunarUtil.CHANG_SHENG_OFFSET[gan];
  // ganIndex 0 (Jia) is Yang (Even index). 1 (Yi) is Yin (Odd index).
  // Yang forward (+), Yin backward (-)
  let index = offset + (ganIndex % 2 === 0 ? zhiIndex : -zhiIndex);
  
  if (index >= 12) index -= 12;
  if (index < 0) index += 12;
  
  return LunarUtil.CHANG_SHENG[index];
};

/**
 * 计算单个柱子的详细信息（相对于日主）
 * @param {string} dayGan 日干
 * @param {string} pillar 柱名（如“甲子”）
 * @returns {object} 柱子的详细信息
 */
export const calculatePillarAnalysis = (dayGan, pillar) => {
  if (!dayGan || !pillar) return {};
  
  const stem = pillar.charAt(0);
  const branch = pillar.charAt(1);
  
  // 藏干
  const hiddenStems = LunarUtil.ZHI_HIDE_GAN[branch] || [];
  
  return {
    ganShiShen: LunarUtil.SHI_SHEN[dayGan + stem] || "",
    zhiShiShen: hiddenStems.map(h => LunarUtil.SHI_SHEN[dayGan + h] || ""),
    naYin: LunarUtil.NAYIN[pillar] || "",
    diShi: calculateDiShi(stem, branch), // 自坐
    xunKong: LunarUtil.getXunKong(pillar),
    starLuck: calculateDiShi(dayGan, branch) // 星运 (日干对地支)
  };
};

/**
 * 计算八字详情（十神、纳音、地势等）
 * @param {number} year 公历年
 * @param {number} month 公历月
 * @param {number} day 公历日
 * @param {number} hour 公历时
 * @returns {object} 包含年、月、日、时四柱的详细信息
 */
export const calculateBaziAnalysis = (year, month, day, hour) => {
  // 构造公历日期
  const solar = Solar.fromYmdHms(Number(year), Number(month), Number(day), Number(hour), 0, 0);
  const lunar = solar.getLunar();
  const bazi = lunar.getEightChar();
  
  // 设置流派（可选，视需求而定，这里使用默认）
  // bazi.setSect(1); 

  return {
    year: {
      ganShiShen: bazi.getYearShiShenGan(), // 年干十神
      zhiShiShen: bazi.getYearShiShenZhi(), // 年支十神（数组，对应藏干）
      naYin: bazi.getYearNaYin(),           // 年柱纳音
      diShi: calculateDiShi(bazi.getYearGan(), bazi.getYearZhi()), // 年柱地势（自坐）
      xunKong: bazi.getYearXunKong(),       // 年柱旬空
      starLuck: bazi.getYearDiShi()         // 星运（日干对年支）
    },
    month: {
      ganShiShen: bazi.getMonthShiShenGan(),
      zhiShiShen: bazi.getMonthShiShenZhi(),
      naYin: bazi.getMonthNaYin(),
      diShi: calculateDiShi(bazi.getMonthGan(), bazi.getMonthZhi()),
      xunKong: bazi.getMonthXunKong(),
      starLuck: bazi.getMonthDiShi()
    },
    day: {
      ganShiShen: "日主",                   // 日干为日主
      zhiShiShen: bazi.getDayShiShenZhi(),
      naYin: bazi.getDayNaYin(),
      diShi: calculateDiShi(bazi.getDayGan(), bazi.getDayZhi()),
      xunKong: bazi.getDayXunKong(),
      starLuck: bazi.getDayDiShi()
    },
    hour: {
      ganShiShen: bazi.getTimeShiShenGan(),
      zhiShiShen: bazi.getTimeShiShenZhi(),
      naYin: bazi.getTimeNaYin(),
      diShi: calculateDiShi(bazi.getTimeGan(), bazi.getTimeZhi()),
      xunKong: bazi.getTimeXunKong(),
      starLuck: bazi.getTimeDiShi()
    }
  };
};